import { request } from './base';

export const syncSession = async (token: string) => {
  const response = await request({
    method: 'POST',
    url: '/connectAuth/sync', 
    data: { token: token }
  });
  return response;
};

export const getCurrentUser = async (email: string) => {  
    const response = await request ({
      method: 'GET', 
      url: `/User/${email}`, 
    }); 
    return response; 
  }; 

export const getCurrentUserInfo = async(token:string) => {
  const response = await request ({
    method: 'GET',
    url: `/Auth2User/CurrentUserInfo`
  });
  return response;
}

export const directLogin = async(endpoint: string, email:string, password:string) => {
  const response = await request ({
    method: 'POST',
    url: `${endpoint}`,
    data: { email: email, password: password }
  });
  return response;
}